import * as React from 'react';

import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import type { KitIconNames } from './types';

export interface FontAwesomeKitIconProps
  extends Omit<FontAwesomeIconProps, 'icon'> {
  icon: KitIconNames;
}

export const FontAwesomeKitIcon: React.FC<FontAwesomeKitIconProps> = ({
  icon,
  color,
  size = 'lg',
  inverse,
  fixedWidth,
  className,
  style,
  pull,
}) => {
  return (
    <i
      className={classNames(
        'fak',
        {
          [`fa-${icon}`]: icon,
          [`fa-${size}`]: size,
          [`fa-pull-${pull}`]: pull,
          'fa-fw': fixedWidth,
          'fa-inverse': inverse,
        },
        className
      )}
      color={color}
      style={style}
    />
  );
};
